import { Box, Grid, Skeleton, Typography } from "@mui/material";
import { DashboardCardWorkspace, IDashboardCardWorkspace } from "../DashboardCard/DashboardCardWorkspace";
import { EmptyContainer } from "../../../../../components/KeydriveComponents/EmptyContainer/EmptyContainer";
import { useTranslation } from "react-i18next";
import { NoWorkspacesOrganizationIcon } from "../../../../../assets/svg/NoWorkspacesOrganizationIcon";
import { useMemo, useState } from "react";
import { FilterRangeUsageStorage } from "../DashboardFilter/FilterRangeUsageStorage";

interface IDashboardDataWorkspaceListProps {
    loading?: boolean;
    data: IDashboardCardWorkspace[];
}

export const DashboardDataWorkspaceList = ({ data, loading }: IDashboardDataWorkspaceListProps) => {
    const { t } = useTranslation();

    const [minUsage, setMinUsage] = useState<number | undefined>();
    const [maxUsage, setMaxUsage] = useState<number | undefined>();

    const isLoading = loading;
    const hasData = !loading && data.length > 0;
    const isEmpty = !loading && data.length === 0;

    const filteredData = useMemo(() => {
        if (!data) return [];
        return data.filter((item) => {
            const usage = item.usedSpace ?? 0;

            if (minUsage !== undefined && usage > minUsage) return false;
            if (maxUsage !== undefined && usage < maxUsage) return false;
            return true;
        });
    }, [data, minUsage, maxUsage]);

    const renderContent = () => {
        if (isLoading) {
            return Array.from(Array(6)).map((_, index) => (
                <Grid item xs={2} sm={4} md={4} key={index} >
                    <Box
                        sx={{
                            background: "#FFFFFF 0% 0% no-repeat padding-box",
                            borderRadius: "4px",
                            opacity: 1,
                            border: "1px solid #0000001A",
                            width: "100%",
                            height: "93px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            padding: "12px",
                        }}
                    >
                        <Skeleton variant="text" width="40%" height={20} />
                        <Skeleton variant="rectangular" width="100%" height={12} sx={{ borderRadius: "2px" }} />
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Skeleton variant="text" width="30%" height={16} />
                            <Skeleton variant="text" width="30%" height={16} />
                        </Box>
                    </Box>

                </Grid>
            ));
        }

        if (hasData) {
            return filteredData.map((item, index) => (
                <Grid item xs={2} sm={4} md={4} key={index} sx={{ width: "100%" }}>
                    <DashboardCardWorkspace {...item} />
                </Grid>
            ));
        }

        if (isEmpty) {
            return (
                <Box width="100%" marginTop={2.5} height="430px">
                    <EmptyContainer
                        content={t('AdminConsole.NoFoundWorkspaceSubtittle')}
                        title={t('AdminConsole.NotFoundWorkspace')}
                        icon={<NoWorkspacesOrganizationIcon />}
                    />
                </Box>
            );
        }

        return null;
    };


    return (
        <>
            {/* Header */}
            <Box sx={{ margin: '5px 0 25px 0' }} display={"flex"} justifyContent="space-between" alignItems="top">
                <Typography
                    sx={{
                        font: "normal normal 600 16px/21px Segoe UI",
                        letterSpacing: "0px",
                        color: "#2D2D2D",
                    }}
                >
                    Workspaces
                </Typography>
                <FilterRangeUsageStorage disabled={isLoading} minUsage={minUsage} maxUsage={maxUsage} setMinUsage={setMinUsage} setMaxUsage={setMaxUsage} />
            </Box>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 8, lg: 12 }} sx={{ overflowY: 'auto', height: '450px', paddingRight: '8px' }}>
                {renderContent()}
            </Grid>
        </>
    );
};
